export const REMEMBER_ME_KEY = 'pe-checkout_rememberMe';
